/* eslint-disable react/require-default-props */
import { BookCard } from "@/components/card";
import {
    useCheckFakeValue,
    useCheckInValue,
    useCheckOutValue,
    useReserveSuccessValue,
    useSetSelectedPerson,
    useSetSelectedRoomState,
} from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center, Spinner } from "@chakra-ui/react";
import { useNewData } from "./hooks";
import { CustomDivider } from "./reservationList.style";
import { type HandleRoomSelectionProps } from "./types";

export const ReservationList = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const checkFake = useCheckFakeValue();
    const { isTablet } = MEDIA();

    const { data, isLoading } = useNewData({ checkIn, checkOut, checkFake });
    const isReserveStatus = useReserveSuccessValue();

    const setSelectedRooms = useSetSelectedRoomState();
    const setSelectedPerson = useSetSelectedPerson();

    const handleRoomSelection = ({ roomIdx, isSelected, newOffPrice, person }: HandleRoomSelectionProps) => {
        setSelectedPerson({ adult: 0, child: 0, infant: 0 });
        setSelectedRooms((prev) => {
            if (isSelected) {
                const updatedRooms = prev.filter((room) => room.roomIdx !== roomIdx);
                return [...updatedRooms, { roomIdx, newOffPrice, person }];
            }

            if (!isSelected) {
                return prev.filter((room) => room.roomIdx !== roomIdx);
            }

            return [];
        });
    };

    if (isLoading || !isReserveStatus) {
        return <Spinner />;
    }

    return (
        <Center
            w="100%"
            // h="720px"
            // overflow="auto"
            justifyContent="flex-start"
            flexDir="column"
            rowGap={isTablet ? "32px" : "24px"}
        >
            {data?.currentRooms.map((currentRoom) => (
                <>
                    <BookCard
                        dayNight={data.dayNights}
                        currentRoom={currentRoom}
                        key={currentRoom.roomIdx}
                        onRoomSelection={handleRoomSelection}
                    />
                    {isTablet && <CustomDivider _last={{ display: "none" }} />}
                </>
            ))}
        </Center>
    );
};
